import {
  Conversation,
  ConversationLogItemParticipantJoined,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui';
import {JoinRow} from '../../Chat/Row/JoinRow';

type Props = {
  conversation: Conversation;
  item: ConversationLogItemParticipantJoined;
  JoinRowComponent?: typeof JoinRow;
};

export const ParticipantJoinedRow = ({
  conversation,
  item,
  JoinRowComponent = JoinRow,
}: Props) => {
  if (item.participant.id === conversation.user.id) {
    return null;
  }

  return (
    <view.div
      className="uh-conversations-contains-meta-row"
      data-testid="conversation-log-participant-joined"
    >
      <JoinRowComponent
        name={item.participant.displayName}
        role={item.participant.role}
      />
    </view.div>
  );
};
